import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { Cart } from '../../../models/_models'
import { routes } from '../../../routes'
import { currencyFormatter } from '../../../utils/functions'
import AppointmentItem from '../../appointment-item'
import Button from '../../Button'
import Typography from '../../Typography'
import AppointmentLocationInfo from '../../appointment-location-info'
import DressCodeInfo from '../../dress-code-info'
import classes from './appointment-review.module.sass'
import CouponForm from '../order-review/CouponForm'

const AppointmentReview = () => {
  const history = useHistory()
  const { customer, setCustomer } = useContext(CustomerContext)
  const [cart, setCart] = useState()

  useEffect(() => {
    if (cart) return

    Cart
      .includes([{ orderPackages: [{ student: ['school'] }, 'apiOption'] }])
      .where({ for_email: [customer.apptCart.id, customer.email] })
      .first()
      .then((res) => {
        setCustomer({ ...customer, apptCart: res.data })
        setCart(res.data)
      })
  }, [cart])

  if (!cart) return null

  return (
    <div className={classes.container}>
      {cart.orderPackages.map((orderPackage) => (
        <AppointmentItem key={orderPackage.id} orderPackage={orderPackage} />
      ))}
      <div className={classes.priceInfo}>
        <Typography>
          Subtotal:
          {' '}
          {currencyFormatter(customer.apptCart.subtotal)}
        </Typography>
        <Typography>
          Tax:
          {' '}
          {currencyFormatter(customer.apptCart.apiTax)}
        </Typography>
        <Typography>
          Total:
          {' '}
          {currencyFormatter(customer.apptCart.apiTotal)}
        </Typography>
      </div>
      <CouponForm appointments />
      <div style={{ width: '80%', margin: '12px auto' }}>
        <AppointmentLocationInfo school={customer.currentSchool} />
        <DressCodeInfo school={customer.currentSchool} />
      </div>
      <Button
        variant="submit"
        classes={classes.purchaseBtn}
        onClick={() => history.push(routes.home({ app: true }))}
      >
        Add Another Appointment
      </Button>
      <Button
        variant="primary"
        classes={classes.purchaseBtn}
        onClick={() => history.push(routes.checkout({ app: true }))}
      >
        Purchase
      </Button>
    </div>
  )
}

export default AppointmentReview
